// extracted by mini-css-extract-plugin
export default {"holisticDescriptionCell":"holisticDescriptionCell__h4iNm","holisticToolbarContainer":"holisticToolbarContainer__oCMOe"};